import { render, staticRenderFns } from "./admin-package-show.vue?vue&type=template&id=328d59b6&scoped=true&"
import script from "./admin-package-show.vue?vue&type=script&lang=js&"
export * from "./admin-package-show.vue?vue&type=script&lang=js&"
import style0 from "./admin-package-show.vue?vue&type=style&index=0&id=328d59b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d59b6",
  null
  
)

export default component.exports